
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initPrincipeSection(section) {
  if (section.dataset.wvAnimInited === "1") return;
  section.dataset.wvAnimInited = "1";

  const title = section.querySelector("h2.global_title");
  const items = gsap.utils.toArray(section.querySelectorAll(".webvibe-principe-item"));
  const imgOne = section.querySelector(".principe-img-one");
  const imgTwo = section.querySelector(".principe-img-two");
  const decors = gsap.utils.toArray(section.querySelectorAll(".wv-decor")); // ✅ несколько декоров

  // ===== Initial states =====
  if (title) gsap.set(title, { autoAlpha: 0, y: 40 });

  // каждый item стартует с разной стороны
  items.forEach((item, index) => {
    const isOdd = (index + 1) % 2 !== 0;
    gsap.set(item, { autoAlpha: 0, x: isOdd ? -110 : 110 }); // сильнее выезд
  });

  if (imgOne) gsap.set(imgOne, { autoAlpha: 0, x: 60, y: 40, scale: 0.96 });
  if (imgTwo) gsap.set(imgTwo, { autoAlpha: 0, x: 60, y: 55, scale: 0.96 });

  if (decors.length) gsap.set(decors, { autoAlpha: 0, scale: 0.97 });

  // ===== Title (один раз) =====
  if (title) {
    ScrollTrigger.create({
      trigger: section,
      start: "top 78%",
      once: true,
      onEnter: () => {
        gsap.to(title, {
          autoAlpha: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          overwrite: "auto",
        });
      },
    });
  }

  // ===== Items appear ON SCROLL (batch) =====
  if (items.length) {
    ScrollTrigger.batch(items, {
      start: "top 88%", // ✅ позже старт, чтобы нижние не “успевали” заранее
      once: true,
      onEnter: (batch) => {
        gsap.to(batch, {
          autoAlpha: 1,
          x: 0,
          duration: 0.9,
          ease: "power4.out",
          stagger: 0.18, // скорость внутри вошедшей пачки
          overwrite: "auto",
        });
      },
    });
  }

  // ===== Images (один раз) =====
  // Триггерим по контейнеру с картинками, чтобы они не появлялись слишком рано
  const imgsTrigger = section.querySelector(".principes-img") || section;

  if (imgOne) {
    ScrollTrigger.create({
      trigger: imgsTrigger,
      start: "top 85%",
      once: true,
      onEnter: () => {
        gsap.to(imgOne, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          scale: 1,
          duration: 1,
          ease: "power4.out",
          overwrite: "auto",
        });
      },
    });
  }

  if (imgTwo) {
    ScrollTrigger.create({
      trigger: imgsTrigger,
      start: "top 82%",
      once: true,
      onEnter: () => {
        gsap.to(imgTwo, {
          autoAlpha: 1,
          x: 0,
          y: 0,
          scale: 1,
          duration: 1,
          ease: "power4.out",
          delay: 0.2, // ✅ вторая чуть позже первой
          overwrite: "auto",
        });
      },
    });
  }

  // ===== Decors (без infinite, с остановкой) =====
// ===== Decors: start BELOW and travel UP along ellipse (once) =====
// ===== Decors: start BELOW and move UP via smooth ellipse (once) =====
if (decors.length) {
  decors.forEach((decor, idx) => {

    // стартовая позиция — ниже
    const startY = 90 + idx * 20;  // ниже финальной точки
    const startX = 0;              // по центру

    // амплитуда дуги
    const arcX = 60 + idx * 20;    // насколько уходит в сторону
    const duration = 1.6 + idx * 0.2;

    gsap.set(decor, {
      autoAlpha: 0,
      y: startY,
      x: startX,
      scale: 0.98,
    });

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      once: true,
      onEnter: () => {
        gsap.to(decor, {
          autoAlpha: 1,
          duration: duration,
          ease: "power3.out",
          keyframes: [
            { x:  arcX, y: startY * 0.6 },  // уходит в сторону и поднимается
            { x: -arcX * 0.4, y: startY * 0.3 }, // мягкий перелом дуги
            { x: 0, y: 0 } // финальная позиция
          ],
          overwrite: "auto",
        });
      }
    });

  });
}
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".wp-block-blocks-webvibe-block-principe")
    .forEach(initPrincipeSection);
});